import React, { useContext } from "react";
import SideBar from "./SideBar/SideBar";
import AuthContext from "../Context/auth-context";
import "./Layout.scss";
import Header from "./Header/Header";
import { getB2BTokens, getUserData } from "../AuthService/userData";

const Layout = ({ children }) => {
  
  const authContext = useContext(AuthContext);
   if (getB2BTokens() != null && process.env.REACT_APP_MAINTAINANCE_MODE != 1) {
    return (
      <>
         <div className="main-layout">
          <Header/>
          <div className="content-container">
          <SideBar />
          <div className="content">
            <div>{children}</div>
          </div>
          </div>
          
        </div>
      </>
    );
  } else {
    return <div>{children}</div>;
  }
};

export default Layout;
